module.exports = "/lucky-balls/img/drum/drum_loop_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_011.png
// module id = 1026
// module chunks = 0